import { Link } from "react-router-dom"
import "../assets/css/error.css"

export default function Error({data}) {
    return(
        <div id="main-site">
            <div className="fof">
                <h1>{data.status}</h1>
                <p>انجام عملیات با خطای زیر مواجه شد!</p>
                <p>{JSON.stringify(data.data.message)}</p>
                <Link to="/" className="btn btn-primary">بازگشت به صفحه اصلی</Link>
            </div>
        </div>
    )
}